import { faBars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import ZoolifeLogo from 'Components/ZoolifeLogo';
import { Layer } from 'grommet';
import { X } from 'lucide-preact';
import { FunctionalComponent } from 'preact';
import { useState } from 'preact/hooks';

import NavMenuContent from '@/components/NavBar/NavMenuContent';
import NavMenuFooter from '@/components/NavBar/NavMenuFooter';
import { useSelector } from '@/redux/helper';

export interface ContentProps {
  onClose: () => void;
}

const Content: FunctionalComponent<ContentProps> = ({ onClose }) => {
  const username = useSelector((store) => store.user.username);
  const isLoggedIn = !!username;

  return (
    <div className="flex h-full flex-col">
      <div className="flex shrink-0 items-center px-6">
        <ZoolifeLogo className="grow" />
        <button type="button" className="preflight preflight-button px-2 py-1" onClick={onClose}>
          <X className="size-5" />
          <span className="sr-only">Close</span>
        </button>
      </div>

      <div className="min-h-0 grow overflow-y-auto">
        <NavMenuContent
          className={clsx('mb-6 mt-3', !isLoggedIn && 'mt-7')}
          onItemClick={() => {
            onClose();
          }}
        />
      </div>

      <NavMenuFooter className="shrink-0 py-3" onItemClick={onClose} />
    </div>
  );
};

const Menu: FunctionalComponent = () => {
  const [showMenu, setShowMenu] = useState(false);

  const onClose = () => {
    setShowMenu(false);
  };

  return (
    <>
      <button type="button" className="preflight preflight-button px-4 text-[22px]" onClick={() => setShowMenu(true)}>
        <FontAwesomeIcon icon={faBars} />
      </button>
      {showMenu && (
        <Layer
          onEsc={onClose}
          onClickOutside={onClose}
          full="vertical"
          position="left"
          className="!max-h-full !min-w-[327px] !bg-white !pb-4 !pt-6"
        >
          <Content onClose={onClose} />
        </Layer>
      )}
    </>
  );
};

export default Menu;
